import { render, staticRenderFns } from "./AddEditAdminUserRoleModal.vue?vue&type=template&id=5f39060d&"
import script from "./AddEditAdminUserRoleModal.vue?vue&type=script&lang=js&"
export * from "./AddEditAdminUserRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports